export default function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/Dom/canUseDom.js
// module id = 241
// module chunks = 0